import script from "./ActivityView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityView.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityView.vue?vue&type=style&index=0&id=9c42d57c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c42d57c"]])

export default __exports__